import React from 'react'
import { Link } from 'gatsby'
import { useAppState } from '../Layout'

export const MobileNavigation = () => {
  const { toggleMenu } = useAppState()
  return (
    <nav className="flex items-center lg:hidden">
      <Link
        to="/virtual-ballot/"
        className="inline-block px-6 pt-2 pb-1 mr-4 font-sans font-bold text-gray-400 no-underline uppercase transition duration-200 border-4 border-brand-yellow sm:text-xl hover:bg-brand-yellow"
      >
        My Ballot
      </Link>
      <button onClick={toggleMenu} className="w-12 h-12 sm:h-16 sm:w-16">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="w-full h-full"
        >
          <path
            className="fill-current"
            d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
          ></path>
        </svg>
      </button>
    </nav>
  )
}
